import {
  Button,
  ConfigProvider,
  DatePicker,
  Divider,
  Spin,
  Tag,
  TimePicker,
} from "antd";
import { ReactComponent as CalendarIcon } from "asset/calendar/calendar.svg";
import { ReactComponent as MeetingNow } from "asset/calendar/meetingNow.svg";
import { ReactComponent as MeetingRoom } from "asset/calendar/meetingRoom.svg";
import axios from "axios";
import DepartmentSelect from "components/calendar/departmentSelect";
import ResourceCalendar from "components/calendar/resourceCalendar";
import ResPop from "components/menu/resPop";
import Mypagedetailpop from "components/mypagecomponents/mypagedetailpop";
import style from "css/calendar.module.css";
import dayjs from "dayjs";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import { updateMeetingTime } from "redux/slices/meetingTimeSlice";
import ko_KR from "antd/lib/locale/ko_KR";
import en_US from "antd/es/locale/en_US";
import Reservepop from "components/calendar/reservepop";

/**
 * 파일명: room.js
 * 작성자: 강연승
 * 작성일자: 23.04.12
 * 설명: 회의실 현황 페이지
 */

function Room({ setType }) {
  //dispatch
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const calendarRangePayload = useSelector((state) => state.calendarRange);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));
  // useEffect(() => {
  //   console.log("date : " + date);
  // }, [date])
  const [time, setTime] = useState({
    start: "",
    end: "",
  });

  const [run, setRun] = useState(false);

  //state
  const [scheduleList, setScheduleList] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [selectDepartMent, setSelectDepartment] = useState({
    DEPT_1: "",
  });
  const [department, setDepartment] = useState({});
  const [meetingRoom, setMeetingRoom] = useState([]);
  const [endpoints, setEndpoints] = useState([]);

  const [pageType, setPageType] = useState("");
  useEffect(() => {
    const tmp = window.location.pathname.split("/");
    const pageName = tmp[tmp.length - 1];
    setPageType(pageName);
  }, []);

  const getDepartment = useCallback(() => {
    let url = "/schedule/department";
    axios.get(url).then((res) => {
      if (res.status === 200) {
        let tmpDepartment = [];
        console.log(res.data.length);
        for (const value in res.data) {
          let tmpArr = [];
          tmpArr.push({ PAR_CD: "", DEPT_CD: "", DEPT_NM: t("LABEL.ALL") });
          tmpArr.push(...res.data[value]);
          tmpDepartment.push(tmpArr);
        }
        setDepartment(tmpDepartment);
      }
    });
  }, [t]);

  const getEndpoint = useCallback(() => {
    let url = "/schedule/endpoint";

    let dept = "";
    for (const value in selectDepartMent) {
      if (selectDepartMent[value] !== "" && dept !== selectDepartMent[value]) {
        dept = selectDepartMent[value];
      }
    }

    let param = {
      params: {
        DEPT_CD: dept,
      },
    };
    axios
      .get(url, param)
      .then((res) => {
        if (res.status === 200) {
          let endpoints = [];
          endpoints = res.data.ENDPOINT.map((data) => {
            return {
              id: data.ENDPOINT_ID,
              title: data.ENDPOINT_NM,
              extendedProps: data,
            };
          });
          // console.log(endpoints);
          setMeetingRoom(endpoints);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectDepartMent]);

  //const [prevDept, setPrevDept] = useState(1);
  const clickDepartment = (index, dept) => {
    if (index === 1 && dept === "") {
      setSelectDepartment({
        DEPT_1: "",
      });
    } else {
      let ghostDept = selectDepartMent;
      let savedDept = [];
      let keys = "";
      for (var k = 1; k < index + 1; k++) {
        keys = "DEPT_" + k;
        if (k === index) {
          savedDept[keys] = dept;
        } else {
          savedDept[keys] = ghostDept[keys];
        }
        keys = "DEPT_" + (k + 1);
      }
      savedDept[keys] = ""; // 다음 DEPT는 초기화
      setSelectDepartment(savedDept);
    }

    /*else if (index < prevDept) {
      setSelectDepartment({
        ...selectDepartMent,
        // [key]: dept,
        DEPT_3: "",
      });
      const { DEPT_3, ...rest } = selectDepartMent;
      setSelectDepartment({
        ...rest,
        [key]: dept,
      });
    } else {
      setSelectDepartment({
        ...selectDepartMent,
        [key]: dept,
      });
    }
    setPrevDept(index);
  */
  };

  const resetSelect = (date) => {
    // eslint-disable-next-line no-unused-expressions
    date === null ? "" : setDate(dayjs(date).format("YYYY-MM-DD"));
    setTime({
      start: "",
      end: "",
    });
    setEndpoints([]);
  };

  const selectTime = (event) => {
    // console.log(moment(event.startStr).format("YYYY-MM-DD"), moment(event.startStr).format("HH:mm:ss"));
    // console.log(moment(event.endStr).format("YYYY-MM-DD"), moment(event.endStr).format("HH:mm:ss"));

    setDate(moment(event.startStr).format("YYYY-MM-DD"));

    setTime({
      start: moment(event.startStr).format("HH:mm:ss"),
      end: moment(event.endStr).format("HH:mm:ss"),
    });

    // const obj = {
    //   TYPE: "CALENDAR",
    //   VIEW: true,
    //   // START_DATE: moment(time.startStr).format("YYYY-MM-DD"),
    //   // END_DATE: moment(time.endStr).format("YYYY-MM-DD"),
    //   // START_TIME: moment(time.startStr).format("HH:mm:ss"),
    //   // END_TIME: moment(time.endStr).format("HH:mm:ss"),
    //   START_DATE: moment(event.startStr).format("YYYY-MM-DD"),
    //   END_DATE: moment(event.endStr).format("YYYY-MM-DD"),
    //   START_TIME: moment(event.startStr).format("HH:mm:ss"),
    //   END_TIME: moment(event.endStr).format("HH:mm:ss"),
    // };
    // dispatch(updateMeetingTime(obj));

    let selectEndpoint = [
      {
        id: event.resource.id,
        name: event.resource.title,
        ENDPOINT_ID: event.resource.id,
        ENDPOINT_NM: event.resource.title,
        ENDPOINT_TYPE: event.resource.extendedProps.ENDPOINT_TYPE,
        ENDPOINT_IP: event.resource.extendedProps.ENDPOINT_IP,
        DEPT_CD: event.resource.extendedProps.DEPT_CD,
        DEPT_NM: event.resource.extendedProps.DEPT_NM,
      },
    ];
    setEndpoints(selectEndpoint);
  };

  const getSchedules = useCallback(() => {
    // if (
    //   calendarRangePayload.ACTIVE_START !== "" &&
    //   calendarRangePayload.ACTIVE_END !== ""
    // ) {
    let url = "/schedule/list";
    let param = {
      params: {
        // ACTIVE_START: calendarRangePayload.ACTIVE_START + "T00:00:00",
        // ACTIVE_END: calendarRangePayload.ACTIVE_END + "T00:00:00",
        ACTIVE_START: moment(date).format("YYYY-MM-DD") + "T00:00:00",
        ACTIVE_END: moment(date).format("YYYY-MM-DD") + "T23:59:59",
        CALENDAR_TYPE: "FULL",
      },
    };
    // dispatch(openLoading());

    axios
      .get(url, param)
      .then((res) => {
        if (res.status === 200) {
          // dispatch(closeLoading());

          let schedules = [];
          schedules = res.data.SCHEDULE.map((data) => {
            return {
              id: data.SCHEDULE_ID + data.ENDPOINT_ID,
              info: data.SCEHDULE_ID,
              title: data.TITLE,
              start: data.START_TIME,
              end: data.END_TIME,
              resourceId: data.ENDPOINT_ID,
              backgroundColor:
                data.SCHEDULE_TYPE === "CD0205" ? "#f1f8f6" : "#fcf6ee",
              borderColor:
                data.SCHEDULE_TYPE === "CD0205" ? "#1cb691" : "#fd9800",
              textColor: "#000",
              extendedProps: {
                ...data,
              },
            };
          });
          // console.log(schedules);
          setScheduleList(schedules);
        }
      })
      .catch(() => {
        // dispatch(closeLoading());
      });
    // }
  }, [date]);

  const meetingTimePayload = useSelector((state) => state.meetingTime);
  useEffect(() => {
    dispatch(
      updateMeetingTime({
        ...meetingTimePayload,
        TYPE: "PICKER",
        VIEW: true,
        // START_DATE: moment(date).format('YYYY-MM-DD'),
        // END_DATE: moment(date).format('YYYY-MM-DD'),
        START_TIME: time.start,
        END_TIME: time.end,
      })
    );
  }, [dispatch, meetingTimePayload, time, date]);

  // const getSchedules = useCallback(() => {
  //   if (
  //     calendarRangePayload.ACTIVE_START !== "" &&
  //     calendarRangePayload.ACTIVE_END !== ""
  //   ) {
  //     let url = "/schedule/list";
  //     let param = {
  //       params: {
  //         ACTIVE_START: calendarRangePayload.ACTIVE_START + "T00:00:00",
  //         ACTIVE_END: calendarRangePayload.ACTIVE_END + "T00:00:00",
  //       },
  //     };
  //     // dispatch(openLoading());

  //     axios
  //       .get(url, param)
  //       .then((res) => {
  //         if (res.status === 200) {
  //           // dispatch(closeLoading());

  //           let schedules = [];
  //           schedules = res.data.SCHEDULE.map((data) => {
  //             if (data.FILE_INFO !== null || data.FILE_INFO !== undefined) {
  //               return {
  //                 id: data.SCHEDULE_ID,
  //                 title: data.TITLE,
  //                 start: data.START_TIME,
  //                 end: data.END_TIME,
  //                 // backgroundColor: "#1cb691",
  //                 // borderColor: "#1cb691",
  //                 extendedProps: {
  //                   scheduleType: data.SCHEDULE_TYPE,
  //                   contents: data.CONTENTS,
  //                   duration: data.DURATION,
  //                   fileInfo: data.FILE_INFO,
  //                   recYN: data.RECORD_YN,
  //                   vcSeq: data.VC_SEQ,
  //                   vcId: data.VC_ID,
  //                   meetingURL: data.MEETING_URL,
  //                   meetingKey: data.MEETING_KEY,
  //                   meetingPw: data.MEETING_PW,
  //                   hostKey: data.HOST_KEY,
  //                   hostId: data.INPUT_ID,
  //                   unlocode: data.UNLOCODE,
  //                   hostNm: data.HOST_NM,
  //                   hostCd: data.HOST_CD,
  //                   hostDeptNm: data.HOST_DEPT_NM,
  //                   hostEmail: data.HOST_EMAIL,
  //                 },
  //               };
  //             } else {
  //               return {
  //                 id: data.SCHEDULE_ID,
  //                 title: data.TITLE,
  //                 start: data.START_TIME,
  //                 end: data.END_TIME,
  //                 extendedProps: {
  //                   scheduleType: data.SCHEDULE_TYPE,
  //                   contents: data.CONTENTS,
  //                   duration: data.DURATION,
  //                   recYN: data.RECORD_YN,
  //                   vcSeq: data.VC_SEQ,
  //                   vcId: data.VC_ID,
  //                   meetingURL: data.MEETING_URL,
  //                   meetingKey: data.MEETING_KEY,
  //                   meetingPw: data.MEETING_PW,
  //                   hostKey: data.HOST_KEY,
  //                   hostId: data.INPUT_ID,
  //                   unlocode: data.UNLOCODE,
  //                   hostNm: data.HOST_NM,
  //                   hostCd: data.HOST_CD,
  //                   hostDeptNm: data.HOST_DEPT_NM,
  //                   hostEmail: data.HOST_EMAIL,
  //                 },
  //               };
  //             }
  //           });
  //           setScheduleList(schedules);
  //         }
  //       })
  //       .catch(() => {
  //         // dispatch(closeLoading());
  //       });
  //   }
  // }, [calendarRangePayload]);

  const [scheduleId, setScheduleId] = useState("");
  const [openDetailPopup, setOpenDetailPopup] = useState(false);
  const openScheduleDetail = (id) => {
    setScheduleId(id);
    setOpenDetailPopup(true);
  };
  const closeScheduleDetail = () => {
    setScheduleId("");
    setOpenDetailPopup(false);
  };

  const [isOpenRes, setIsOpenRes] = useState(false);
  const closeRes = () => {
    setIsOpenRes(false);
    setScheduleId("");
    const obj = {
      TYPE: "",
      VIEW: false,
      START_DATE: "",
      END_DATE: "",
      START_TIME: "",
      END_TIME: "",
    };

    setripop(false);
    setRun(false);
    setTime({
      start: "",
      end: "",
    });
    dispatch(updateMeetingTime(obj));
    closePop();
  };
  const closePop = () => {
    setripop(false);
  };

  const openRes = (Res) => {
    setIsOpenRes(true);
    setSchedule(Res);
  };
  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  useEffect(() => {
    getDepartment();
  }, [getDepartment]);

  useEffect(() => {
    setLoading(true);
    getEndpoint();
    getSchedules();
  }, [getEndpoint, getSchedules, selectDepartMent]);

  const [ripop, setripop] = useState(false);

  // const [time, setTime] = useState({
  //   start: "",
  //   end: "",
  // });

  const getSystemType = useCallback(() => {
    axios
      .get("/schedule/systemInfo")
      .then((res) => {
        if (res.status === 200) {
          setVcType(res.data.SYSTEM_TYPE);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [vcType, setVcType] = useState("");
  useEffect(() => {
    getSystemType();
  }, [getSystemType]);

  useEffect(() => {
    if (run && time.start !== "" && time.end !== "") {
      let obj = {
        PROCESS_TYPE: "C",
        TITLE: "",
        CONTENTS: "",
        SCHEDULE_TYPE: vcType,
        OPEN_YN: "Y",
        RECORD_YN: "N",
        MEETING_PW: "",
        START_TIME: dayjs(date + " " + time.start).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        END_TIME: dayjs(date + " " + time.end).format("YYYY-MM-DD HH:mm:ss"),
        MAIL_YN: "Y",
        PARTICIPANT_LIST: [],
        ENDPOINT_LIST: endpoints,
        ATTACHMENT_LIST: [],
      };
      setSchedule(obj);
      setripop(true);

      setIsOpenRes(true);
    }
    setRun(false);
  }, [date, endpoints, run, time.end, time.start, vcType]);

  const openRi = (Res) => {
    setEndpoints(Res.ENDPOINT_LIST);
    setripop(true);
    setSchedule(Res);
  };

  return (
    <div className={style.resource_wrapper}>
      <Mypagedetailpop
        open={openDetailPopup}
        close={closeScheduleDetail}
        SCHEDULE_ID={scheduleId}
        PAGE_TYPE={pageType}
        refresh={getSchedules}
        // refresh={() => window.location.reload()}
        isOpenRes={(res) => {
          openRi(res);
        }}
      />

      <div className={ripop ? style.ripop : style.ripopc}>
        <Reservepop
          isOpenRes={isOpenRes}
          close={closeRes}
          setSchedule={setSchedule}
          schedule={schedule}
          getScheduleList={getSchedules}
          PAGE_TYPE={pageType}
          refresh={getSchedules}
          date={date}
          startTime={time.start}
          endTime={time.end}
          endpointId={endpoints.length > 0 ? endpoints[0].id : ""}
        />
      </div>

      <div className={style.resource_header}>
        <div className={style.btn_area}>
          <div className={style.btn_calendar_type}>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    colorPrimary: "#1cb691",
                    fontFamily: "Spoqa Han Sans Neo",
                    // colorPrimaryActive: "#1cb691",
                    // colorPrimaryHover: "#1cb691",
                  },
                },
              }}
            >
              {/* <a href={process.env.REACT_APP_CLIENT_URL + "app/meeting/room"} > */}
              <Button
                className={style.btn}
                icon={<MeetingRoom />}
                size="large"
                type="primary"
              // onClick={() =>
              // navigate(
              //   process.env.REACT_APP_CLIENT_URL + "app/meeting/room"
              // )
              // }
              >
                {t("BTN.ROOM_STATUS")}
              </Button>
              {/* </a> */}
            </ConfigProvider>

            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    colorPrimaryActive: "#1cb691",
                    colorPrimaryHover: "#1cb691",
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                },
              }}
            >
              <Button
                className={`${style.btn} ${style.unactive}`}
                icon={<CalendarIcon />}
                size="large"
                onClick={() => {
                  // navigate(
                  //   process.env.REACT_APP_CLIENT_URL + "app/meeting/calendar"
                  // )
                  setType("calendar");
                }}
              >
                {t("BTN.CALENDAR")}
              </Button>
            </ConfigProvider>
          </div>

          {/* <div className={style.view_type_btn_area}>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    colorPrimary: "#1cb691",
                    colorPrimaryHover: "#1AA886",
                    colorPrimaryActive: "#1cb691",
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                },
              }}
            >
              <Button
                className={style.meeting_now_btn}
                type="primary"
                size="large"
                icon={<MeetingNow />}
                onClick={() => {
                  let obj = {
                    PROCESS_TYPE: "C",
                    TITLE: "",
                    CONTENTS: "",
                    SCHEDULE_TYPE: "CD0205",
                    OPEN_YN: "Y",
                    RECORD_YN: "N",
                    MEETING_PW: "",
                    START_TIME: getReserveDateTime(new Date(), 0),
                    END_TIME: getReserveDateTime(new Date(), 30),
                    PARTICIPANT_LIST: [],
                    ENDPOINT_LIST: [],
                    MAIL_YN: "Y",
                    ATTACHMENT_LIST: [],
                  };
                  openRes(obj);
                }}
              >
                {t("BTN.INSTANT_MEETING")}
              </Button>
            </ConfigProvider>
          </div> */}
        </div>

        <div className={style.select_area}>
          <div className={style.select_header}>
            <span
              className={style.select_title}
              onClick={() => setripop(false)}
            >
              {t("ROOM_STATUS.TITLE")}
            </span>
          </div>
          <div className={style.select_contents}>
            <div className={style.location_select}>
              <span className={style.select_item_title}>
                {t("ROOM_STATUS.LOCATION")}
              </span>
              <div className={style.locaion_select_content}>
                {Array.isArray(department) && department.length > 0 ? (
                  department.map((dept, index) => (
                    <DepartmentSelect
                      key={"department_" + index}
                      deptNum={index}
                      department={dept}
                      selectDepartMent={selectDepartMent}
                      clickDepartment={clickDepartment}
                      value={
                        index === 0
                          ? selectDepartMent.DEPT_1
                          : index === 1
                            ? selectDepartMent.DEPT_2
                            : index === 2
                              ? selectDepartMent.DEPT_3
                              : ""
                      }
                    />
                  ))
                ) : (
                  <></>
                )}
              </div>
            </div>
            <ConfigProvider
              theme={{
                token: {
                  fontSize: "47.5px",
                  colorSplit: "#bfbfbf",
                },
              }}
            ></ConfigProvider>

            <ConfigProvider
              theme={{
                token: {
                  fontSize: "47.5px",
                  colorSplit: "#bfbfbf",
                },
              }}
            ></ConfigProvider>
            <div className={style.meeting_date_time_select}>
              <div className={style.meeting_date_select}>
                <span className={style.select_item_title}>
                  {t("ROOM_STATUS.RESERVATION_DATE")}
                </span>
                <ConfigProvider
                  theme={{
                    token: {
                      fontFamily: "Spoqa Han Sans Neo",
                    },
                    components: {
                      DatePicker: {
                        colorLink: "#1cb691",
                        colorLinkHover: "1cb691",
                        colorBgContainerDisabled: "#fff",
                        colorTextDisabled: "#000",
                      },
                    },
                  }}
                  locale={i18n.language === "en_US" ? en_US : ko_KR}
                >
                  <DatePicker
                    className={style.meeting_datepicker}
                    size="large"
                    // disabled
                    disabledDate={(current) =>
                      current.isBefore(dayjs().subtract(1, "day"))
                    }
                    value={date === "" ? null : dayjs(date, "YYYY-MM-DD")}
                    // onChange={(date) =>
                    //   date === null
                    //     ? ""
                    //     : setDate(dayjs(date).format("YYYY-MM-DD"))
                    // }
                    // onChange={date => navigate(process.env.PUBLIC_URL + "?DATE=" + date)}
                    // onChange={date => handleDateChange(date)}
                    onChange={resetSelect}
                  />
                </ConfigProvider>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="spin-container">
          <Spin />
        </div>
      ) : (
        <div key={date} className={style.resource_calendar_container}>
          <ResourceCalendar
            scheduleList={scheduleList}
            resource={meetingRoom}
            selectTime={selectTime}
            eventClick={openScheduleDetail}
            // resetSelect={resetSelect}
            date={date}
            openPopup={() => setRun(true)}
            alertStatus={ripop}
          />
        </div>
      )}
    </div>
  );
}

export default Room;
